import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import './MatchedVisasDashboard-Mobile-experiment-1.scss';

const BenefitsSection = () => {
    const listItems = [
        'Reveal your chances of success for each visa type.',
        'Analyse your assessment report with a visa expert.',
        'Get data driven insights based on your report.',
        'Get expert advice on your top visa options.',
    ];

    const getListItems = (items: string[]) => {
        return items.map((item, i) => (
            <>
                <div className="stage__icon">
                    <CheckIcon className="check" />
                </div>
                <div className="grid-item-E1">{item}</div>
            </>
        ));
    };

    return (
        <div className="BenefitsSection" style={{ marginTop: '0.5rem' }}>
            <div className="Header2">
                <span className="Title">Benefits of expert consultation:</span>
            </div>
            <div className="grid-container2">{getListItems(listItems)}</div>
        </div>
    );
};

export default BenefitsSection;
